var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_87_809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7249 19.9999C29.7249 14.6289 25.3709 10.2749 19.9999 10.2749C14.6289 10.2749 10.2749 14.6289 10.2749 19.9999C10.2749 25.3709 14.6289 29.7249 19.9999 29.7249C25.3709 29.7249 29.7249 25.3709 29.7249 19.9999Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.765 18.855H21.145V16.235C21.145 15.595 20.625 15.085 19.995 15.085C19.365 15.085 18.845 15.605 18.845 16.235V18.855H16.225C15.585 18.855 15.075 19.375 15.075 20.005C15.075 20.635 15.595 21.155 16.225 21.155H18.845V23.775C18.845 24.415 19.365 24.925 19.995 24.925C20.625 24.925 21.145 24.405 21.145 23.775V21.155H23.765C24.405 21.155 24.915 20.635 24.915 20.005C24.915 19.375 24.395 18.855 23.765 18.855Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_87_809"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.45,
    height: 21.45,
    fill: "white",
    transform: "translate(9.2749 9.2749)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddOutline);
export default __webpack_public_path__ + "static/media/add-outline.0d87660b3b085cee0ca22e6ab72c3e32.svg";
export { ForwardRef as ReactComponent };